<template>
    <div class="opui-col">


        <div class="opui-form-group">
            <div class="opui-input-group">
                <input type="text" placeholder="value" class="opui-form-control" v-model="field.value" required />
                <SearchInput :url="selectUrl"
                             :hideInput="true"
                             @change="dynamicInsertChange"
                             :placeholder="'Dynamic'" />
            </div>
        </div>




        <!-- <RichSelect
            v-model="selectedDynamic"
            modelValue="selectedDynamic"
            :settings="selectSettings"
            :ajaxUrl="selectUrl"
            :placeholder="'Dynamic'"
            @select="dynamicInsertChange"
        /> -->

    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"
import SearchInput from "../../Global/SearchInput.vue"

export default {
    components: { RichSelect, SearchInput },
    props: {
        workflow: { type: Object, required: true },
        item:     { type: Object, required: true },
        field:    { type: Object, required: true },
    },
    computed: {
        selectSettings() {
            return { ajax: { url: this.selectUrl, dataType: 'json' }, minimumResultsForSearch: -1 }
        },

        selectUrl() {
            let path = 'flow/item-fields?workflow_uid=' + this.workflow.uid

            if (this.item.uid) {
                path = path + '&item_uid=' + this.item.uid
            }

            return this.restUrl(path)
        },
    },
    data() {
        return {
            selectedDynamic: '',
            options: [
                {
                    text: 'Global Data',
                    children: [
                        { id: '%global/date%',       text: 'Date' },
                        { id: '%global/date_day%',   text: 'Day' },
                        { id: '%global/date_month%', text: 'Month' },
                        { id: '%global/date_year%',  text: 'Year' },
                        { id: '%global/date_time%',  text: 'Time' },
                    ],
                },
                {
                    text: 'Webhook Data',
                    children: [
                        { id: '%email%', text: 'Text' },
                    ],
                }
            ]
        }
    },
    methods: {
        dynamicInsertChange(selected) {
            this.field.value = this.field.value + selected.id
            this.selectedDynamic = null
            selected = null
        }
    }
}
</script>
